<template>
    <div class="main-filter">
        <div class="container">
            <div class="form">
                <div class="head">
                    <form class="search-products w-50" @submit.prevent="searchProducts()">
                        <div class="cont">
                            <div class="form-group">
                                <input type="text" class="col-md" v-model="search_products" placeholder="Название продукта">
                                <button class="btn" type="submit">Поиск</button>
                            </div>
                        </div>
                    </form>

                    <div class="bottom">
                        <div class="form-group" v-bind:class="{disabled: getSubscribeProductsAmount <= 0}">
                            <input type="checkbox" name="" id="waiting_list"
                                   v-if="getSubscribeProductsAmount > 0 ? 'disabled': ''">

                            <label @click="changeWaitingList" for="waiting_list" class="switch">
                                <span class="slider round"></span>
                            </label>

                            <label @click="changeWaitingList" for="waiting_list" class="title">
                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                <span>Ожидаемые поступления</span>
                                <span v-if="getSubscribeProductsAmount> 0" class="waiting_list_quantity">{{ getSubscribeProductsAmount }}</span>
                            </label>
                        </div>
                    </div>

                    <a @click="getExel" class="catalog" style="cursor: pointer"><i class="fa fa-download" aria-hidden="true" ></i> Скачать .xls</a>
                    <a id="downloadExel" :href="this.axios.defaults.baseImageURL + 'exports/products.xls'" style="position: absolute; opacity: 0; pointer-events: none" download=""></a>
                </div>
            </div>

            <div class="products" v-click-outside="hideSeachedProducts">
                <table v-if="searched_products != null && searched_products.length > 0" class="table table-hover">
                    <thead class="thead">
                    <tr>
                        <td></td>
                        <td>Код</td>
                        <td>Наименование</td>
                        <td>Остаток</td>
                        <td class="text-center">Цена тг</td>
                        <td class="text-center">Заказ (колич.)</td>
                        <td class="text-center">Итог</td>
                    </tr>
                    </thead>

                    <tbody class="tbody">
                    <product-tr
                            v-for="(product) in searched_products"
                            :product="product"
                            :key="product.id"
                            :waitingIcon=false
                    ></product-tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductTr from "./Product";
    import {mapActions, mapGetters} from "vuex";
    import Vue from "vue";

    Vue.directive('click-outside',{
        bind: function (el, binding, vnode) {
            el.eventSetDrag = function () {
                el.setAttribute('data-dragging', 'yes');
            }
            el.eventClearDrag = function () {
                el.removeAttribute('data-dragging');
            }
            el.eventOnClick = function (event) {
                var dragging = el.getAttribute('data-dragging');
                // Check that the click was outside the el and its children, and wasn't a drag
                if (!(el == event.target || el.contains(event.target)) && !dragging) {
                    // call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.addEventListener('touchstart', el.eventClearDrag);
            document.addEventListener('touchmove', el.eventSetDrag);
            document.addEventListener('click', el.eventOnClick);
            document.addEventListener('touchend', el.eventOnClick);
        }, unbind: function (el) {
            document.removeEventListener('touchstart', el.eventClearDrag);
            document.removeEventListener('touchmove', el.eventSetDrag);
            document.removeEventListener('click', el.eventOnClick);
            document.removeEventListener('touchend', el.eventOnClick);
            el.removeAttribute('data-dragging');
        },
    });
    export default {
        name: "FilterC",
        props: ['categories'],

        data () {
            return {
                brands: null,
                selected: 'all',
                waitingList: false,
                searched_products: null,
                search_products: null,
            }
        },

        mounted() {
            console.log(this.getSubscribeProductsAmount);
        },

        methods:{
            ...mapActions({
                getProductsWithBasketAction: 'pushProductsWithBasket',
            }),

            getExel(){
                let downloadExel = document.getElementById('downloadExel');
                this.axios
                    .get(this.axios.defaults.baseURL + 'get-exel')
                    .then(response => {
                        if (response.data.message === 'success'){
                            downloadExel.click()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            searchChange(asd){
                if (this.searched_products !== null && this.searched_products.length !== 0){
                    this.searched_products = null;
                }
            },
            selectChange(){
                this.$emit('changeFilterCategory', this.selected)
            },

            changeWaitingList(){
                this.waitingList = !this.waitingList
                this.$emit('changeWaitingList', this.waitingList)
                // console.log(this.waitingList)
            },

            searchProducts() {
                if (this.search_products != null && this.search_products.length >= 3) {
                    this.axios
                        .get(this.axios.defaults.baseURL + 'search-products', {
                            params: {
                                'search_products': this.search_products
                            }
                        })
                        .then(response => {
                            this.getProductsWithBasketAction({ products: response.data.products }).then(response => {
                                this.searched_products = response
                            })
                            // console.log(this.searched_products)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },
            hideSeachedProducts(){
                this.searched_products = null;
                // this.search_products = null;
            }
        },

        computed: {
            ...mapGetters([
                'getSubscribeProductsAmount',
            ]),
        },
        components: {
            ProductTr,
        }
    }
</script>

<style scoped>

    .waiting_list_quantity{
        background-color: #cccccc;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
    }

    .form-group.disabled{
        opacity: 0.35;
        pointer-events: none;
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/Filter.vue